import './App.css';

import React, { useState } from 'react';

const ppl = [
  ["Elonas Muskas", "https://i.dailymail.co.uk/1s/2023/07/14/23/73237437-12300909-image-m-30_1689374056519.jpg"],
  ["Gitanas Nausėda", "https://pasauliolietuvis.lt/wp-content/uploads/2020/07/Lietuvos-Respublikos-Prezidentas-Gitanas-Naus%C4%97da-2.jpg"],
  ["Vytautas Didysis", "https://s1.15min.lt/static/cache/MTkyMHgxMDgwLDIxOXgxNzQsNjE2MjA0LG9yaWdpbmFsLCxpZD0yMjQ0NzMmZGF0ZT0yMDEwJTJGMDklMkYwNyw0MDkzOTgxNTk2/1283882267vytautas_didysis.jpg"],
  ["Dievas Ra", "https://cdn.thecollector.com/wp-content/uploads/2023/10/who-is-ra-egyptian-sun-god.jpg?width=1400&quality=70"],
  ["Jėzus", "https://m.media-amazon.com/images/I/816Etq5qEwL._AC_UF1000,1000_QL80_.jpg"],
  ["Vladimiras Putinas", "https://upload.wikimedia.org/wikipedia/commons/5/51/%D0%92%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80_%D0%9F%D1%83%D1%82%D0%B8%D0%BD_%2818-06-2023%29_%28cropped%29.jpg"],
  ["LIDL", "https://karjera.lidl.lt/images/variations/hero/4/7/1/8/93028174-1-lit-LT/LIDL%20parduotuve.jpg"],
  ["Audi", "https://g2.dcdn.lt/images/pix/bmw-88515095.jpg"],
  ["Nigerijos princas", "https://i.kym-cdn.com/entries/icons/facebook/000/012/475/nigerian-prince.jpg"],
  ["Lietuvos Čigonų Institucija", "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Points_of_a_horse.jpg/330px-Points_of_a_horse.jpg"],
  ["MR Breast", "https://i.ytimg.com/vi/0e3GPea1Tyg/maxresdefault.jpg"],
  ["西蒙纳斯·朱吉利尤斯 (UK Prezidentas)", "https://cdn-0001.qstv.on.epicgames.com/FVDAzHWRAFVtYrmfDe/image/screen_comp.jpeg"],
  ["Lietuvos Darbo Inspekcija", "https://lvra.lt/wp-content/uploads/2021/02/download-2.jpg"],
  ["Valstybės mokesčių inspekcija", "https://www.anyksciai.lt/data/public/uploads/2016/01/73.png.jpg"],
  ["Vilijamas sekspyras", "https://www.lrt.lt/img/2019/06/03/441124-121592-1287x836.jpg"],
  ["Obuolys Uoga", "https://8diena.lt/wp-content/uploads/2018/03/balys-sruoga-2-638.jpg"],
  ["Džefris Einšteinas", "https://hips.hearstapps.com/hmg-prod/images/jeffrey-epstein-attends-launch-of-radar-magazine-at-hotel-news-photo-591529968-1562782199.jpg?crop=1xw:0.5xh;center,top&resize=1200:*"],
  ["Stevenas Hokingas", "https://i.ytimg.com/vi/Ih9fG4iywuY/maxresdefault.jpg"],
  ["Rayanas Žasiukas", "https://m.media-amazon.com/images/M/MV5BMTQzMjkwNTQ2OF5BMl5BanBnXkFtZTgwNTQ4MTQ4MTE@._V1_.jpg"]
]

const prizes = [
  "2,46 € 💶💶", 
  "Mein kampf knygą 🦄",
  "Hesburger sūrainio kuponą 🥳",
  "2 600 000 mln. rublių 🥳",
  "2 KG aukso 🎉",
  "6 KG sidabro 🎉",
  "Dvi cigaretes 🎉",
  "2 420 000 mln. rublių 🥳",
  "McDonalds restoraną 😯",
  "LIDL Freeway Cola (x2) 😯",
  "420 000 Litų 😯",
  "Tesla Model S 😯",
  "Juodą arklį 🦄",
  "4,86 € 💶💶",
  "2 Cepelinus 😶😶",
  "18 ml gamtinių dujų",
  "Ketvirtadalį lenko (Kojas)🎉",
  "Ketvirtadalį lenko (Rankas)🎉",
  "Ketvirtadalį lenko (Galvą)🎉",
  "8 pupeles 🎉",
  "22,4 Tonas Urano 🎉",
  "Tuščią stiklainį 🎉",
  "Baravyką 🍆",
  "Perpjautą centą",
  "Naująjį iPhone 23 🎉",
  "Nigerijos princą 🎉",
  "Privačia savaitės kelionę į Černobylio atomą 🎉",
  "Privačią salą 🔥🔥",
  "Pakvietimą į privačią salą 😉😋🍆",
  "Kelionę į marsą 🪐",
  "Kelionę į saulę 🌞",
  "Kelionę į krematoriumą 💀💀💀",
  "Kelionę į ligoninę 🏥",
  "Kelionę į kapines 🪦",
  "Pakvietimą į Lietuvos Respublikos Prezidentūrą 🎉",
  "Pakvietimą į tarnybą Izraelio kariuomenėje 🎉",
  "Pakvietimą į tarnybą Rusijos kariuomenėje 🎉",
  "Kelionę į sibirą 🥶🥶🥶",
  "Pepsi skonio Miau 😋😋"
]

const whys = [
  "kryžiuočių nugalėjimo proga!",
  "rusijos įstojimo į Nato proga!",
  "jūsų gimtadienio proga!",
  "LDK atkūrimo proga!",
  "Jungtinės karalystės įstojimo į Europos sąjungą proga!",
  "Arklių sugražinimo žmonėms iš čigonų proga!",
  "Nes jūs buvote geras berniukas!",
  "Naujų metų proga!",
  "Dalios Grybauskaitės gimimo dienos proga!",
  "Medienos atidavimo barsukams proga!",
  "Valdžios perversmo proga!",
  "Jūsų gimimo dienos proga!",
  "Vilniaus sunaikinimo proga!",
  "Lenkijos nugalėjimo progą!",
  "Karo su rusais pradžios proga!",
  "Karo su lenkais pradžios proga!",
  "Karo su latviais pradžios proga!",
]

var CCount = 6.9

var cppl = ppl[Math.floor(Math.random() * (ppl.length))]
var cprize = prizes[Math.floor(Math.random() * (prizes.length))]
var cwhy = whys[Math.floor(Math.random() * (whys.length))]

function App() {
  const [count, setCount] = React.useState(6.9);

  function HotMilfs(){
    document.getElementById("hotMilfs").style.animation = "opacity 1s ease forwards";

    setInterval(function(){ 
      if(CCount < 0.8){CCount -= 0.008}
      else{CCount -= 0.1}

      if(CCount > 0){setCount(Math.floor(CCount * 10) / 10)}
    }, 300);
  }
  
  return (
    <div className="App">
      <div id="imgDiv">
        <img src={cppl[1]} alt=""></img>
      </div>
      <div id="hotMilfs">
        <img src={cppl[1]} alt=""></img>
        <div>{cppl[0]} {count} km nuo jūsų lokacijos!</div>

        <a href='tel:6969696969'>Skambinti 😍😍🥰😘</a>
      </div>
      <div id='Main'>
        <div className='text'>
          <h2>🎉🎉💯 Sveikiname! 🥳🥳🎈</h2>
          <p>{cppl[0]} jums dovanoja <span className='colorGreen'>{cprize}</span> <br />{cwhy} 🥳🥳</p>
        
          <div id='form'>
            <h4>Prašome užpildyti formą kad galėtumėte atsiimti prizą</h4>
            <div>Asmens tapatybės kodas: <input type="text" /> <br /></div>
            <div>Telefono numeris: <input type="tel" /><br /></div>
            <div>Banko kortelės numeriai: <input type="num"/><br /></div>
            <div>Banko kortelės CCV: <input type="num"/><br /></div>
            <div>Banko kortelės Galiojimo data: <input type="month"/><br /></div>
            <div>Banko kortelės PIN1: <input type="num"/><br /></div>
            <div>Banko kortelės PIN2: <input type="num"/><br /></div>
            <div>El. paštas: <input type="email"/><br /></div>
            <div>El. pašto slaptažodis: <input type="text"/><br /></div>
            <div>Namų adresas: <input type="text"/><br /></div>
            <br></br>
            <button onClick={() => HotMilfs()}>Pateikti ir gauti prizą 🥳</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
